"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const react_hooks_1 = require("@apollo/react-hooks");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const GET_DUPLICATED_STOCKS = graphql_tag_1.default `
  query {
    getDuplicatedStocks {
      _id
      stock {
        warehouse
        product {
          name
        }
      }
    }
  }`;
const CLEAR_DUPLICATED_STOCKS = graphql_tag_1.default `
  mutation {
    clearDuplicatedStocks {
      _id
    }
  }
`;
const IMPORT_AND_BUILD_ALL = graphql_tag_1.default `
  mutation importAndBuildAll {
    importAll
    buildAll
  }
`;
function StockManagementAdminView() {
    const [importAndBuildAll, { loading, error }] = react_hooks_1.useMutation(IMPORT_AND_BUILD_ALL);
    const { data, refetch, loading: loadingDuplicated, } = react_hooks_1.useQuery(GET_DUPLICATED_STOCKS);
    const [clearDuplicatedStocks, { loading: loadingClearDuplicatedStocks, }] = react_hooks_1.useMutation(CLEAR_DUPLICATED_STOCKS);
    if (loading || loadingDuplicated || loadingClearDuplicatedStocks) {
        return react_1.default.createElement(core_1.CircularProgress, null);
    }
    if (error) {
        return react_1.default.createElement(react_1.default.Fragment, null, error);
    }
    if (loadingDuplicated) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Button, { onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                    e.preventDefault();
                    yield importAndBuildAll();
                }) }, "\u91CD\u65B0\u532F\u5165\u8207\u5EFA\u7F6E")));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Button, { onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                e.preventDefault();
                yield clearDuplicatedStocks().then(refetch);
            }) }, "\u6E05\u9664\u91CD\u8907"),
        react_1.default.createElement(core_1.Button, { onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                e.preventDefault();
                yield importAndBuildAll();
            }) }, "\u91CD\u65B0\u532F\u5165\u8207\u5EFA\u7F6E"),
        react_1.default.createElement(core_1.List, null, data.getDuplicatedStocks.map(e => react_1.default.createElement(core_1.ListItem, { key: e._id }, `${e.stock.warehouse}: ${e.stock.product.name}`)))));
}
function StockManagementAdmin({ client, }) {
    return (react_1.default.createElement(react_hooks_1.ApolloProvider, { client: client },
        react_1.default.createElement(StockManagementAdminView, null)));
}
exports.default = StockManagementAdmin;
